/**
 * `\root` → `\sqrt`.
 *
 * KaTeX has no `\root`, yet models write roots with it: gemini-2.5-flash read
 * `2√10` as `2\root{2}\text{10}` nine times on one paper (RG-01 Test-10,
 * 2026-10-27), and the teacher saw red source. The number in braces is the
 * root's INDEX — `\root{2}` is the square root, `\root{3}` the cube root — and
 * the `\text{}` round the argument holds maths, not prose, so it goes too.
 * Plain TeX's `\root 3 \of {x}` is the same command and is read the same way.
 * A `\root` with no index is left alone: there is nothing to say which root.
 */

/** A root's argument: braces nested up to two deep (`\text{\frac{5}{6}}`). */
const ROOT_ARG = String.raw`((?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*)`;

const ROOT = new RegExp(
    String.raw`\\root(?![A-Za-z])\s*(?:\{\s*(\w+)\s*\}|(\w+))\s*(?:\\of\s*)?(?:\\text\s*)?\{` + ROOT_ARG + String.raw`\}`,
    'g',
);

export function rewriteRoots(latex: string): string {
    if (!latex.includes('\\root')) return latex;
    return latex.replace(ROOT, (_m, braced?: string, bare?: string, arg = '') => {
        const index = braced ?? bare;
        return index === '2' ? `\\sqrt{${arg}}` : `\\sqrt[${index}]{${arg}}`;
    });
}
